<template>
    <button type="button" @click="onPressed">{{ label }}</button>
  </template>
  
  <script>
  export default {
    name: 'ButtonComponent',
    props: {
      label: {
        type: String,
        required: true
      },
      onPressed: {
        type: Function,  // La prop attend une fonction
        required: true   
      }
    }
  }
  </script>
  